import React from 'react';
import { FormattedMessage } from 'react-intl';

const LoadingCellRenderer = () => {
    return (
        <div>
            <FormattedMessage id="common_loading" />
        </div>
    );
};

export default LoadingCellRenderer;
